// `.ts` required — this module is pulled into Deno-bundled edge functions via
// connection-capabilities.ts, and Deno will not resolve an extensionless
// relative specifier. See the note in connection-capabilities.ts.
import { getPlatformLabel } from './identity.ts';

export const PLATFORMS = {
  instagram: {
    id: 'instagram',
    label: getPlatformLabel('instagram'),
    publishable: true,
    oauthReady: true,
  },
  facebook: {
    id: 'facebook',
    label: getPlatformLabel('facebook'),
    publishable: true,
    oauthReady: true,
  },
  tiktok: {
    id: 'tiktok',
    label: getPlatformLabel('tiktok'),
    publishable: true,
    oauthReady: true,
  },
  linkedin: {
    id: 'linkedin',
    label: getPlatformLabel('linkedin'),
    publishable: true,
    oauthReady: true,
  },
  youtube: {
    id: 'youtube',
    label: getPlatformLabel('youtube'),
    publishable: false,
    oauthReady: true,
    comingSoonNote:
      'YouTube connects for channel analytics today. Publishing support will come later.',
  },
  pinterest: {
    id: 'pinterest',
    label: getPlatformLabel('pinterest'),
    publishable: false,
    oauthReady: true,
    comingSoonNote:
      'Pinterest connects for board and analytics sync today. Publishing support will come later.',
  },
} as const;

export type PlatformId = keyof typeof PLATFORMS;
export const PLATFORM_IDS = Object.keys(PLATFORMS) as PlatformId[];
export const POSTABLE_PLATFORMS: PlatformId[] = PLATFORM_IDS.filter(
  (id) => PLATFORMS[id].publishable && PLATFORMS[id].oauthReady,
);
